let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6biq")).then(() => parcelRequire('6SFLx'));